import { render, staticRenderFns } from "./CouponOverview.vue?vue&type=template&id=471bf622&"
import script from "./CouponOverview.vue?vue&type=script&lang=js&"
export * from "./CouponOverview.vue?vue&type=script&lang=js&"
import style0 from "./CouponOverview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports